import { useContext, useState } from 'react';
import { SiteContentContext } from '../context/SiteContentContext';
import { useGeo, coordsMapUrl } from '../context/GeoContext';
import Icon from '../components/Icon';
import QuestionModal from '../components/QuestionModal';
import { useSeo } from '../hooks/useSeo';
import '../styles/info_page.css';
import '../styles/fleet_page.css';

const Info = () => {
  useSeo({
    title: 'Контакты и о школе',
    description: 'Контакты парусной школы The Sailing Doctor: как связаться, где мы находимся, о нашей команде и подходе к обучению.',
  });
  const { content } = useContext(SiteContentContext);
  const country = useGeo();
  const [isQuestionOpen, setIsQuestionOpen] = useState(false);

  return (
    <main>
      <section className={`fleet-page-hero${content.infoHeroImage ? ' has-cover' : ''}`} style={content.infoHeroImage ? { backgroundImage: `url(${content.infoHeroImage})` } : {}}>
        <h1>Контакты</h1>
      </section>
      <div className="info-page">
        <section className="contacts-section">
          <div className="contact-items">
            {content.address && (
              <div className="contact-item">
                <Icon name="pin" size={18}/>
                <p>{content.address}</p>
              </div>
            )}
            {content.phone && (
              <div className="contact-item">
                <Icon name="phone" size={18}/>
                <p>{content.phone}</p>
              </div>
            )}
            {content.email && (
              <div className="contact-item">
                <Icon name="email" size={18}/>
                <a href={`mailto:${content.email}`}>{content.email}</a>
              </div>
            )}
            {content.telegram && (
              <div className="contact-item">
                <Icon name="telegram" size={18}/>
                <a href={content.telegram} target="_blank" rel="noopener noreferrer">Telegram</a>
              </div>
            )}
            {content.coordinates && (() => {
              const toDDM = (deg, isLat) => {
                const d = Math.floor(Math.abs(deg));
                const m = ((Math.abs(deg) - d) * 60).toFixed(2);
                const dir = isLat ? (deg >= 0 ? 'N' : 'S') : (deg >= 0 ? 'E' : 'W');
                return `${d}°${m}'${dir}`;
              };
              const [lat, lng] = content.coordinates.split(',').map(Number);
              const label = `${toDDM(lat, true)}, ${toDDM(lng, false)}`;
              return (
                <div className="contact-item">
                  <Icon name="map" size={18}/>
                  <a href={coordsMapUrl(content.coordinates, country)} target="_blank" rel="noopener noreferrer">
                    {label}
                  </a>
                </div>
              );
            })()}
          </div>
        </section>
      </div>
      <section className="cta-section">
        <h2>Остались вопросы?</h2>
        <p>Напишите нам — ответим в течение дня.</p>
        <button className="cta-button" onClick={() => setIsQuestionOpen(true)}>Задать вопрос</button>
      </section>
      <QuestionModal isOpen={isQuestionOpen} onClose={() => setIsQuestionOpen(false)} pageTitle="Контакты" />
    </main>
  );
};

export default Info;
